import Icon from '../components/Icon.vue'

Icon.register({"mouse-pointer":{"width":320,"height":512,"paths":[{"d":"M302.2 329.1H196.1L251.9 465.1C255.8 474.5 251.4 485.1 242.5 489.1L193.3 510.5C184.2 514.5 173.9 510 170 500.8L116.9 371.7 30.3 460.8C18.7 472.7 0 463.6 0 448V18.3C0 1.9 19.9-6.1 30.3 5.4L314.7 298C326.2 309.2 317.7 329.1 302.2 329.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mouse-pointer.js
// module id = u1F5
// module chunks = 0